<template>
  <div class="page">
    <div class="p16">纸质档案</div>
    <div class="page-head">
      <div class="mains-content">
        <div class="member-content-box br10">
          <div class="member-header">
            <div class="flex-row">
              <el-input placeholder="请输入手机号码/姓名" v-model="query.keyword" clearable maxlength="11" class="mr10"
                prefix-icon="el-icon-search"></el-input>
              <el-button type="primary" @click="rulesMobile">搜索</el-button>
            </div>
            <el-button type="primary" @click="addClick()"
              v-perm="{ key: 'repairCard', value: 'repairCard:add' }">新增</el-button>
          </div>
          <div class="plr16" v-perm="{ key: 'repairCard', value: 'repairCard:list' }">
            <el-table :data="list" :max-height="height - 266" header-cell-class-name="table_header_bgcolor">
              <el-table-column :align="item.align" :label="item.label" :width="item.width" :min-width="item.minWidth"
                :show-overflow-tooltip="false" v-for="(item, index) in columns" :key="index">
                <template slot-scope="scope">
                  <div v-if="index == 'gender'">{{ scope.row.gender == 'male' ? '男' : '女' }}</div>
                  <div v-else>{{ Boolean(item.formatDay) ? formatDay(scope.row[index]) : scope.row[index] }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="amt" label="操作" align="center" width="100" fixed="right">
                <template slot-scope="scope">
                  <el-link type="primary" @click="addClick(scope.row)">编辑</el-link>
                  <el-link type="primary" class="ml10" @click="detailPage(scope.row)">详情</el-link>
                </template>
              </el-table-column>
            </el-table>
            <paging :totalCount="totalCount" @doPageQuery="doDataQuery"></paging>
          </div>
        </div>
      </div>
    </div>
    <edit-set ref="editSetForm" @change="editChange"></edit-set>
    <detail-set ref="detailSetForm"></detail-set>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import config from "./config/columns";
import editSet from "./edit";
import detailSet from "./detail";
export default {
  mixins: [minxin],
  data() {
    return {
      columns: config.columns,
      list: [],
      url: this.$url.paperRepairDocument.list,
      query: {
        keyword: ""
      },
      height: this.$store.getters.MainHeight,
    };
  },
  components: {
    editSet,
    detailSet
  },
  created() {
    this.totalCounts();
  },

  methods: {
    back() {
      this.$router.push("/dataList");
    },
    addClick(item) {
      item == undefined
        ? this.$refs["editSetForm"].$emit("set", null)
        : this.$refs["editSetForm"].$emit("set", item);
    },
    rulesMobile() {
      this.list = [];
      this.query.start = 1;
      this.totalCounts();
    },
    removeDoQuery() {
      this.query = {
        keyword: "",
        start: 1,
        size: 20
      };
      this.totalCounts();
    },
    editChange(bool) {
      if (bool) {
        this.query = {
          keyword: "",
          start: 1,
          size: 20
        };
        this.totalCounts();
      }
    },
    totalCounts() {
      this.totalCount = 0;
      this.$api.post(this.$url.paperRepairDocument.count, this.query).then(res => {
        this.getData();
        this.totalCount = res;
      }).catch(error => { });
    },
    detailPage(item) {
      this.$refs["detailSetForm"].$emit("set", item);
    }
  }
};
</script>

<style scoped lang="less">
@import "../../../assets/css/edit.less";

.page-head {
  height: 100%;
}

.mains-content {
  .member-content-box {
    background-color: #fff;

    .member-header {
      padding: 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
}
</style>